/**
 * Bronzata GLOBAL content protection
 * Loaded once via theme.liquid → protects every page (PDP, home, collections, cart…).
 *
 * Blocks (best-effort, browser-supported):
 *   - Right-click / context menu on <img> and <video>  → no "Save as..."
 *   - Long-press save on iOS / Android (via touch-callout + contextmenu prevent)
 *   - Drag-and-drop of <img> to desktop / external apps
 *   - HTML5 video download / PiP / remote playback / playback-rate menu
 *   - Drag selection of media surfaces
 *
 * Cannot prevent (structural web limits):
 *   - DevTools (F12) / Network tab / View Source
 *   - OS screenshots
 *   - 3rd-party download extensions
 */
(function(){
  if (window.__bronzataProtectInit) return;
  window.__bronzataProtectInit = true;

  function stop(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();
    return false;
  }

  function hardenImg(img) {
    if (!img || img.__bzProtected) return;
    img.__bzProtected = true;
    img.setAttribute('draggable', 'false');
    img.style.webkitUserDrag = 'none';
    img.style.userDrag = 'none';
    img.style.webkitTouchCallout = 'none';
    img.addEventListener('contextmenu', stop, true);
    img.addEventListener('dragstart',   stop, true);
  }

  function hardenVideo(v) {
    if (!v || v.__bzProtected) return;
    v.__bzProtected = true;
    /* HTML5 attributes — block download UI in browser's video menu */
    v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('disableremoteplayback', '');
    v.style.webkitTouchCallout = 'none';
    v.addEventListener('contextmenu', stop, true);
    v.addEventListener('dragstart',   stop, true);
  }

  function scan(root) {
    var rootEl = root || document;
    var imgs = rootEl.querySelectorAll ? rootEl.querySelectorAll('img') : [];
    for (var i = 0; i < imgs.length; i++) hardenImg(imgs[i]);
    var vids = rootEl.querySelectorAll ? rootEl.querySelectorAll('video') : [];
    for (var j = 0; j < vids.length; j++) hardenVideo(vids[j]);
  }

  /* Global capture-phase listener: catches contextmenu on ANY img/video
     even if the element didn't get individual listeners (race conditions). */
  document.addEventListener('contextmenu', function(e) {
    var t = e.target;
    if (!t) return;
    var tag = (t.tagName || '').toUpperCase();
    if (tag === 'IMG' || tag === 'VIDEO' || tag === 'PICTURE' || tag === 'SOURCE') {
      stop(e);
    } else if (t.closest && (t.closest('img,picture,video,source'))) {
      stop(e);
    }
  }, true);

  /* Block any dragstart on images globally */
  document.addEventListener('dragstart', function(e) {
    var t = e.target;
    var tag = t && (t.tagName || '').toUpperCase();
    if (tag === 'IMG' || tag === 'PICTURE') stop(e);
  }, true);

  /* Initial sweep */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { scan(); });
  } else {
    scan();
  }

  /* Mutation observer — protects dynamically-added media (carousels, infinite scroll, AJAX, etc.) */
  if (window.MutationObserver && document.body) {
    var startObserver = function() {
      var mo = new MutationObserver(function(muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            var tag = (n.tagName || '').toUpperCase();
            if (tag === 'IMG') hardenImg(n);
            else if (tag === 'VIDEO') hardenVideo(n);
            else if (n.querySelectorAll) scan(n);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) startObserver();
    else document.addEventListener('DOMContentLoaded', startObserver);
  }
})();
